import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { thunkShowPlayerInfo } from '../../redux/actions/playerInfoActions';
import { useAppDispatch } from '../../redux/store';
import { FRIENDS_PANEL_LIST_ITEM_HOVER_COLOR } from '../../styles/colors';
import { assertUnreachable } from '../../utils/tsUtils';
import { PanelItem } from '../panelItem';
import { AcceptFriendModal } from './acceptFriendModal';
import { SentFriendRequestModal } from './sentFriendRequestModal';
export const ActiveContactPanelItem = ({ activeContact }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const [isAcceptFriendModalOpen, setIsAcceptFriendModalOpen] = useState(false);
    const [isSentFriendRequestModalOpen, setIsSentFriendRequestModalOpen] = useState(false);
    const onClick = useCallback(() => {
        switch (activeContact.activeContactType) {
            case 'admins': {
                dispatch(thunkShowPlayerInfo({ id: activeContact.playerId, name: activeContact.username }, socketSend));
                break;
            }
            case 'helpers': {
                dispatch(thunkShowPlayerInfo({ id: activeContact.playerId, name: activeContact.username }, socketSend));
                break;
            }
            case 'friends': {
                dispatch(thunkShowPlayerInfo({ id: activeContact.playerId, name: activeContact.username }, socketSend));
                break;
            }
            case 'requests_received': {
                setIsAcceptFriendModalOpen(true);
                break;
            }
            case 'requests_sent': {
                setIsSentFriendRequestModalOpen(true);
                break;
            }
            default: {
                assertUnreachable(activeContact.activeContactType);
            }
        }
    }, [dispatch, activeContact.activeContactType, activeContact.playerId, activeContact.username, socketSend]);
    return (_jsxs(_Fragment, { children: [_jsx(PanelItem, { onClick: onClick, hoverColor: FRIENDS_PANEL_LIST_ITEM_HOVER_COLOR, children: activeContact.username }), isAcceptFriendModalOpen && (_jsx(AcceptFriendModal, { username: activeContact.username, onClose: () => setIsAcceptFriendModalOpen(false) })), isSentFriendRequestModalOpen && (_jsx(SentFriendRequestModal, { username: activeContact.username, onClose: () => setIsSentFriendRequestModalOpen(false) }))] }));
};
